export default "__VITE_ASSET__DJrRsv_2__"